export class QuotingModel {
    public formati: Array<Object>;
    public formato: Array<Object>;
    public categorieCarte: Array<Object>;
    public categorieCarteCount: number = 0;
    public categorieCarteInterno: Array<Object>;
    public categorieCarteCopertina: Array<Object>;
    public categorieCarteCopertinaCount: number = 0;
    public carte1: Array<Object>;
    public carte1Count: number = 0;
    public carte2: Array<Object>;
    public carte2Count: number = 0;
    public colori1: Array<Object>;
    public colori1Count: number = 0;
    public colori2: Array<Object>;
    public colori2Count: number = 0;
    public grammature1: Array<Object>;
    public grammature1Count: number = 0;
    public grammature2: Array<Object>;
    public grammature2Count: number = 0;
    public plastificazioni1: Array<Object>;
    public plastificazioni1Count: number = 0;
    public plastificazioni2: Array<Object>;
    public plastificazioni2Count: number = 0;
    public piegature: Array<Object>;
    public piegatureCount: number = 0;
    public coloriStampaInterno: Array<Object>;
    public materialiFlessibili: Array<Object>;
    public materialiFlessibiliCount: number = 0;
    public copie: Array<Object>;
    public copieCount: number = 0;
    public supportiRigidi: Array<Object>;
    public supportiRigidiCount: number = 0;
    public lavorazioniAccessorie: Array<MyLavorazioneAccessoria>;
    public elettrosaldature: Array<Object>;
    public elettrosaldatureCount: number = 0;
    public tagli: Array<Object>;
    public tagliCount: number = 0;
    public coloriCarte: Array<Object>;
    public copertine: Array<Object>;
    public copertineCount: number = 0;
    public coloriStampaCopertina: Array<Object>;
    public rilegature: Array<Object>;
    public rilegatureCount: number = 0;
    public facciate: Array<Object>;
    public facciateCount: number = 0;
    public facciateComePagine: boolean;
    public tipologieBusta: Array<Object>;
    public tipologieBustaCount: number = 0;
    public taglio: string;
    public numCopie: string;
    public idCopie: string;
    public numSoggetti: string;
    public numFacciate: string;
    public idFacciate: string;
    public categorieCarteId: number;
    public categorieCarteIdCopertina: number;
    public tipoCopie: string;
    public minimoCopie: number;
    public minimoFacciate: number;
    public massimoFacciate: number;
    public multiploFacciate: number = 0;
    public tipoStampaCopertinaSoloFronte: boolean;
    public tipoColoriOffset: string;
    public plastificazioneInterno: string;
    public cartacopertina: string;
    public plastificazioneCopertina: string;
    public soggettiMultipli: boolean;
    public formatoPersonalizzato: boolean;
    public massimoCopie: number;
    public minimoBase: number;
    public massimoBase: number;
    public minimoAltezza: number;
    public massimoAltezza: number;
    public disposizione_asola: string;
    public tipoFacciate: string;
    public tipoTaglio: boolean;
    public tipoStampaInternoSoloFronte: boolean;
    public tipoCalcoloTaglio: string;
    public listaRegole: Array<Regola>;
    public listaRegoleGrammaturaFacciate: Array<any>;
    public idCarte1: string;
    public idCopertine: string;
    public idCarte2: string;
    public idPlastificazioni1: string;
    public idPlastificazioni2: string;
    public idRilegature: string;
    public idFormati: string;
    public idGrammature1: string;
    public idGrammature2: string;
    public idColori1: string;
    public idColori2: string;
    public idPiegature: string;
    public idRifili: string;
    public idTagli: string;
    public idCategorieCarte1: string;
    public idCategorieCarte2: string;
    public stampa1_colori_fronte: string;
    public stampa1_colori_retro: string;
    public stampa2_colori_fronte: string;
    public stampa2_colori_retro: string;
    public copieIsValid: boolean = true;
    public facciateIsValid: boolean = true;
    public formatiIsValid: boolean = true;
    public carte1IsValid: boolean = true;
    public grammature1IsValid: boolean = true;
    public carte2IsValid: boolean = true;
    public grammature2IsValid: boolean = true;
    public copertineIsValid: boolean = true;
    public rilegatureIsValid: boolean = true;
    public lavorazioniIsValid: boolean = true;
    public copieMessage: string;
    public facciateMessage: string;
    public formatiMessage: string;
    public carte1Message: string;
    public grammature1Message: string;
    public carte2Message: string;
    public grammature2Message: string;
    public copertineMessage: string;
    public rilegatureMessage: string;
    public taglioShowed: boolean = false;
    public isTaglioVisible: boolean = false;
    public valueStampaInternoSoloFronte: boolean;
    public valueStampaCopertinaSoloFronte: boolean;
    public calculationType: string;
    public isWizardWithScontistica: boolean;
    public formatoDescription: string;
    public formatoImage: string;
    public formatiShowInfo: boolean;
    public formatiHasInfo: boolean;
    public carte1Description: string;
    public carte1Image: string;
    public carte1ShowInfo: boolean;
    public carte1HasInfo: boolean;
    public carte2Description: string;
    public carte2Image: string;
    public carte2ShowInfo: boolean;
    public carte2HasInfo: boolean;
    public plastificazioni1Description: string;
    public plastificazioni1Image: string;
    public plastificazioni1ShowInfo: boolean;
    public plastificazioni1HasInfo: boolean;
    public plastificazioni2Description: string;
    public plastificazioni2Image: string;
    public plastificazioni2ShowInfo: boolean;
    public plastificazioni2HasInfo: boolean;
    public rilegatureDescription: string;
    public rilegatureImage: string;
    public rilegatureShowInfo: boolean;
    public rilegatureHasInfo: boolean;

    public copieOrder: number = 0;
    public facciateOrder: number = 0;
    public formatiOrder: number = 0;
    public stampaInternoFronteOrder: number = 0;
    public stampaInternoOrder: number = 0;
    public carteInternoOrder: number = 0;
    public plastificazioniInternoOrder: number = 0;
    public copertineOrder: number = 0;
    public stampaCopertinaFronteOrder: number = 0;
    public stampaCopertinaOrder: number = 0;
    public cartaCopertinaOrder: number = 0;
    public plastificazioniCopertinaOrder: number = 0;
    public cartoncinoOrder: number = 0;
    public rilegatureOrder: number = 0;
    public rifiloOrder: number = 0;
    public lavorazioniAccessorieOrder: number = 0;
    public companyNumber: string;
    public companyEmail: string;
    public companyCondizioni: string;

    public piegatureDescription: string;
    public piegatureImage: string;
    public piegatureShowInfo: boolean;
    public piegatureHasInfo: boolean;
    public piegatureIsValid: boolean = true;
    public piegatureMessage: string;

    public plastificazione1IsValid: boolean = true;
    public plastificazione1Message: string;

    public plastificazione2IsValid: boolean = true;
    public plastificazione2Message: string;

    public soggettiOrder: number = 0;
    public soggettiIsValid: boolean = true;
    public soggettiMessage: string;
    public baseFormato: string;
    public altezzaFormato: string;
    public baseFormatoIsValid: boolean = true;
    public baseFormatoMessage: string = "";
    public altezzaFormatoIsValid: boolean = true;
    public altezzaFormatoMessage: string = "";
    public formatiMultipliIsValid: boolean = true;

    public formatiVisual: boolean = false;
    public stampaInternoVisual: boolean = false;
    public carteInternoVisual: boolean = false;
    public plastificazioniInternoVisual: boolean = false;
    public copertineVisual: boolean = false;
    public stampaCopertinaVisual: boolean = false;
    public cartaCopertinaVisual: boolean = false;
    public plastificazioniCopertinaVisual: boolean = false;
    public rilegatureVisual: boolean = false;
    public lavorazioniAccessorieVisual: boolean = false;
    public piegatureVisual: boolean = false;

    public taglioOrder: number = 0;
    public taglioDescription: string;
    public taglioImage: string;
    public taglioShowInfo: boolean;
    public taglioHasInfo: boolean;
    public taglioIsValid: boolean = true;
    public taglioMessage: string;

    public bustaOrder: number = 0;
    public bustaDescription: string;
    public bustaImage: string;
    public bustaShowInfo: boolean;
    public bustaHasInfo: boolean;
    public bustaIsValid: boolean = true;
    public bustaMessage: string;
    public idBusta: string;

    public materialeOrder: number = 0;
    public materialeDescription: string;
    public materialeImage: string;
    public materialeShowInfo: boolean;
    public materialeHasInfo: boolean;
    public materialeIsValid: boolean = true;
    public materialeMessage: string;
    public idMaterialiFlessibili: string;

    public supportoOrder: number = 0;
    public supportoDescription: string;
    public supportoImage: string;
    public supportoShowInfo: boolean;
    public supportoHasInfo: boolean;
    public supportoIsValid: boolean = true;
    public supportoMessage: string;
    public idSupportiRigidi: string;
    public idGruppo: number = 0;

    public occhiellaturaOrder: number = 0;
    public occhiellaturaDescription: string;
    public occhiellaturaImage: string;
    public occhiellaturaShowInfo: boolean;
    public occhiellaturaHasInfo: boolean;
    public occhiellaturaIsValid: boolean = true;
    public occhiellaturaMessage: string;
    public idOcchielli: string;
    public disposizione_occhielli_id: string;
    public distanza_occhielli: string;
    public occhielli: Array<Object>;
    public occhielliCount: number = 0;
    public occhielliDisposizione: Array<Object>;
    public occhielliDisposizioneCount: number = 0;
    public asolaOrder: number = 0;
    public asolaDescription: string;
    public asolaImage: string;
    public asolaShowInfo: boolean;
    public asolaHasInfo: boolean;
    public asolaIsValid: boolean = true;
    public asolaMessage: string;
    public idAsole: string;
    public diametro_asola: string;
    public disposizione_asola_id: string;
    public asole: Array<Object>;
    public asoleCount: number = 0;
    public asoleDisposizioni: Array<Object>;
    public asoleDisposizioniCount: number = 0;
    public cucituraOrder: number = 0;
    public cucituraDescription: string;
    public cucituraImage: string;
    public cucituraShowInfo: boolean;
    public cucituraHasInfo: boolean;
    public cucituraIsValid: boolean = true;
    public cucituraMessage: string;
    public idCuciture: string;
    public disposizione_cucitura_id: string;
    public cuciture: Array<Object>;
    public cucitureCount: number = 0;
    public cucitureDisposizioni: Array<Object>;
    public cucitureDisposizioniCount: number = 0;
    public elettroOrder: number = 0;
    public elettroDescription: string;
    public elettroImage: string;
    public elettroShowInfo: boolean;
    public elettroHasInfo: boolean;
    public elettroIsValid: boolean = true;
    public elettroMessage: string;
    public idElettrosaldature: string;
    public disposizione_elettrosaldatura_id: string;
    public elettrosaldatureDisposizioni: Array<Object>;
    public elettrosaldatureDisposizioniCount: number = 0;
    public bifaccialeOrder: number = 0;
    public stampaBifacciale: number;
    public tipoBifacciale: string;
    public biancoCoprenteOrder: number = 0;
    public biancoCoprente: Array<Object>;
    public biancoCoprenteCount: number = 0;
    public idBiancoCoprente: string;

    public oraOrdine: string;
    public richiesteScontistica: string;

    public distanzaOcchielliIsValid: boolean = true;
    public distanzaOcchielliMessage: string;

    public diametroAsolaIsValid: boolean = true;
    public diametroAsolaMessage: string;


    public pantoni: Array<Object>;
    public pantoniCount: number = 0;
    public idPantoneFronte1: string;
    public pantoneFronte1Description: string;
    public pantoneFronte1Image: string;
    public pantoneFronte1HasInfo: boolean;
    public pantoneFronte1ShowInfo: boolean;
    public pantoneFronte1Visual: boolean;

    public idPantoneFronte2: string;
    public pantoneFronte2Description: string;
    public pantoneFronte2Image: string;
    public pantoneFronte2HasInfo: boolean;
    public pantoneFronte2ShowInfo: boolean;
    public pantoneFronte2Visual: boolean;
    public idPantoneRetro1: string;
    public pantoneRetro1Description: string;
    public pantoneRetro1Image: string;
    public pantoneRetro1HasInfo: boolean;
    public pantoneRetro1ShowInfo: boolean;
    public pantoneRetro1Visual: boolean;
    public idPantoneRetro2: string;
    public pantoneRetro2Description: string;
    public pantoneRetro2Image: string;
    public pantoneRetro2HasInfo: boolean;
    public pantoneRetro2ShowInfo: boolean;
    public pantoneRetro2Visual: boolean;
    public colori1IsValid: boolean = true;
    public colori1Message: string;

    //Cartoncino
    public cartoncinoIsValid: boolean = true;
    public cartoncinoHasInfo: boolean;
    public cartoncinoVisual: boolean = false;
    public idCartoncino: string;
    public cartoncini: Array<Object>;
    public cartonciniCount: number = 0;
    public cartoncinoMessage: string;
    public cartoncinoShowInfo: boolean;
    public cartoncinoImage: string;
    public cartoncinoDescription: string;
    public grammatureCartoncinoIsValid: boolean = true;
    public idGrammatureCartoncino: string;
    public grammatureCartoncino: Array<Object>;
    public grammatureCartoncinoCount: number = 0;
    public grammatureCartoncinoMessage: string;
    public FilesCombinazioniObj: FileCombinationModel;
    public ManageAttachment: string;
    public isStampaInternoRequired: boolean;
    public isStampaCopertinaRequired: boolean;
    public isStampaBifaccialeSiHide: boolean;
    public isStampaBifaccialeNoHide: boolean;
    public IsPackagingWizard: boolean;
    public listaPackagingParameter: Array<any>;
    public basePackagingIsValid: boolean = true;
    public profonditaPackagingIsValid: boolean = true;
    public idBasePackaging: number = 0;
    public idProfonditaPackaging: number = 0;
    public basePackagingMessage: string;
    public profonditaPackagingMessage: string;
    public formatiCount: number = 0;
    public gapLabel: number = 0;
    public tipologiaLavoriLabel: Array<any>;
    public avvolgimentiLabel: Array<any>;
    public diametroInterno: number = 0;
    public diametroMassimoEsterno: number = 0;
    public ListafustelleLabel: Array<any>;
    public TipologiaFormatiLabel: Array<any>;
   
    public subSection: string;
    public formatiTipoOrder: number;
    public formatiTipoImgPath: string;
    public formatiTipoVisual: boolean;
    public formatiTipoImage: string;
    public formatiTipoHasInfo: boolean;
    public formatiTipoLabelCount: number = 0;
    public formatiTipoLabelShowInfo: boolean;
    public formatiTipoLabelIsValid: boolean = true;

    public idFormatoTipo: string;
    public fustelleOrder: number;
    public idFustella: string;
    public fustelleLabelCount: number = 0;
    public fustellaLabelIsValid: boolean = true;

    public idTipoLavoroLabel: string;

    public avvolgimentiOrder: number;
    public avvolgimentiImgPath: string;
    public avvolgimentiVisual: boolean;
    public avvolgimentiImage: string;
    public avvolgimentiHasInfo: boolean;
    public idAvvolgimento: string;
    public avvolgimentiCount: number = 0;
    public avvolgimentiShowInfo: boolean;
    public avvolgimentiIsValid: boolean = true;

    public numEtichetteOrder: number;
    public numEtichetteImgPath: string;
    public numEtichetteIsValid: boolean = true;
    public numEtichetteMessage: string;
    public numEtichette: string = "1";

    public massimaDistanzaEtichetteLabel: number;
    public minimaDistanzaEtichetteLabel: number;

    public DiametroInternoAnimaEditabileLabel: boolean = false;
    public numDiametroInternoAnimaEditabileLabel: number;
    public DiametroInternoAnimaIsValid: boolean = true;
    public DiametroInternoAnimaMessage: string;
    public numDiametroInternoAnimaLabel: number;
    

    public numDiametroMassimoEsternoAnimaEditabile: number;
    public DiametroMassimoEsternoAnimaEditabile: boolean = false;
    public DiametroMassimoEsternoAnimaIsValid: boolean = true;
    public DiametroMassimoEsternoAnimaMessage: string;
    public numDiametroMassimoEsternoAnimaLabel: number;

    public diametriOrder: number;
    public diametriImgPath: string;
    public isPlastificazioneRequired: boolean;
    public isFormatiMultiliEnabled: boolean;

}
export class FileCombinationModel {
    listaFilesCombinazioni: any[];
    FormatList: any[];
    PiegheList: any[];
}

export class Object {
    public chiave: string;
    public valore: string;
    public selected: boolean;
    public isVisible: boolean = true;
    public subElements: Array<Object>;
    public wrap_valore: string;
    public parentId: string;
    public descrizione: string;
    public image: string;
    public hasInfo: boolean;
    public colorExaForMatrix: string;
    public mostraPerVariantiMatrice: number;
}

export class WizardListinoScontistica {
    public rowId: number;
    public columnId: number;
    public value: string;
    public buttonWizardListino: string;
}

export class SelectObject {
    public chiave: string;
    public valore: string;
}
export class MyVarianteMatrice {
    public id: number;
    public nome: string;
    public colore: string;
    public popup: string;
    public imgPath: string;
    public mostraPerVariantiMatrice: string;
    public qta: number;
    public VarianteVerticale: Array<MyVarianteMatrice>;
    public VarianteOrizzontale: Array<MyVarianteMatrice>;
}
export class MyLavorazioneAccessoria {
    public id: number;
    public type: string;
    public isValid: boolean = false;
    public isVisible: boolean = true;
    public lavId: number;
    public nome: string;
    public tipo: string;
    public tipoSelezione: string;
    public valore: string;
    public valori: Array<Object>;
    public valoriCount: number = 0;
    public value: any;
    public selected: boolean;
    public obbligatorio: boolean;
    public isCalculated: boolean;
    public lavorazioneCheckValue: boolean;
    public lavorazioneMessage: string;
    public description: string;
    public image: string;
    public showInfo: boolean;
    public hasInfo: boolean;
    public maxQtaInput: number;
    public minQtaInput: number;
    public idVarianteMatriceVerticale: number;
    public idVarianteMatriceOrizzontale: number;
    public VarianteMatrix: Array<MyVarianteMatrice>;
    public umLavorazione: number;
    public percentualePagineTotEditoria: number;
}

export class Regola {
    public Id: number;
    public Nome_Regola: string;
    public Tipo: string;
    public Categoria_1: string;
    public Sezione_1: string;
    public Id_Elemento_1: number;
    public Categoria_2: string;
    public Sezione_2: string;
    public Id_Elemento_2: number;
    public IdRegoleCategoria: number;
    public Id_Elemento_Sottochiave_1: number;
    public Id_Elemento_Sottochiave_2: number;
    public Tipo_Regola: string;
    public Flag_Copertina_1: boolean;
    public Flag_Copertina_2: boolean
    public Macro_Categoria_1: string;
    public Macro_Categoria_2: string;
    public Attivo: boolean;
}


export class MyLavorazioneAccessoriaReturn {
    public id: number;
    public value: string;
}

export class LavorazioniComponents {
    public checkBox: number = 0;
    public inputBox: number = 1;
    public selectBox: number = 2;
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/models/document/quoting-model.ts